import { AsyncPipe } from '@angular/common';
import { ChangeDetectionStrategy, Component, computed, inject, signal } from '@angular/core';
import { toSignal } from '@angular/core/rxjs-interop';
import { RouterLink } from '@angular/router';
import { map } from 'rxjs';
import { freePlanMaxSeats } from '../../../billing-consts';
import { PricingService } from '../../../services/pricing.service';
import { StateService } from '../../../services/state.service';
import { TenantService } from '../../../services/tenant.service';
import { CustomCurrencyPipe } from '../../../shared/pipes/custom-currency.pipe';

@Component({
  selector: 'app-team-invite-charge-text',
  standalone: true,
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [CustomCurrencyPipe, RouterLink, AsyncPipe],
  templateUrl: './team-invite-charge-text.component.html',
  styleUrl: './team-invite-charge-text.component.scss',
})
export class TeamInviteChargeTextComponent {
  public state = inject(StateService);
  private tenantService = inject(TenantService);
  private pricingService = inject(PricingService);
  public seatAddonPrice$ = this.pricingService.getPrices('seat_addon').pipe(
    map(prices => {
      const id = this.state.plan.price.metadata.seat_addon_price_id;
      return prices.find(price => price.id === id);
    })
  );

  memberCount = toSignal(this.tenantService.getMembers().pipe(map(members => members.length)));
  inviteCount = toSignal(this.tenantService.getPendingInvites().pipe(map(invites => invites.length)));
  isFree = signal<boolean>(this.state.plan.isFree);
  maxInviteCount = computed(() =>
    this.isFree() ? freePlanMaxSeats - this.memberCount() - this.inviteCount() : Infinity
  );
  canInvite = computed(() => this.maxInviteCount() > 0);
  includedInviteCount = computed(() => this.state.plan.includedSeatCount - this.memberCount());
}
